import TitleWrapper from 'components/custom/TitleWrapper'
import { eTypographyVariant } from 'components/types'
import React from 'react'

interface Props {
  data: Record<string, string>[]
}

export const BOMProcessedTable: React.FC<Props> = ({ data }) => {
  if (data.length === 0) return null

  const headers = Object.keys(data[0])

  return (
    <div className="mt-4">
      <TitleWrapper
        variant={eTypographyVariant.h3}
        className="font-semibold mb-2"
      >
        Parsed BOM Table
      </TitleWrapper>
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr>
            {headers.map((key) => (
              <th
                key={key}
                className="border-b px-3 py-2 text-left bg-gray-100"
              >
                {key}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {headers.map((key, i) => (
                <td key={i} className="border px-3 py-1">
                  {row[key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
